export const ticketMock = '192b7352-e56f-4366-9f6c-c88005960750';